import { fetchMainApi } from '@/api'

export const getEquipment = async () => {
  return fetchMainApi('GET', '/trucks')
}

export const getEquipmentById = async (id) => {
  return fetchMainApi('GET', `/trucks/${id}`)
}

export const createEquipment = async (data) => {
  return fetchMainApi('POST', '/trucks', {
    body: JSON.stringify(data)
  })
}

export const updateEquipment = async (id, data) => {
  return fetchMainApi('PUT', `/trucks/${id}`, {
    body: JSON.stringify(data)
  })
}

export const deleteEquipment = async (id) => {
  return fetchMainApi('DELETE', `/trucks/${id}`)
}

export const uploadEquipmentImage = async (equipmentId, file) => {
  const formData = new FormData()
  formData.append('file', file)

  return fetchMainApi(
    'POST',
    `/trucks/${equipmentId}/images`,
    { body: formData },
    'multipart/form-data'
  )
}

export const uploadEquipmentImages = async (equipmentId, files) => {
  const uploadedImages = []

  for (const file of files) {
    try {
      const response = await uploadEquipmentImage(equipmentId, file)
      uploadedImages.push(response.data)
    } catch (error) {
      console.error(`Failed to upload ${file.name}:`, error)
      throw error
    }
  }

  return { data: uploadedImages }
}

export const getEquipmentImages = async (equipmentId) => {
  return fetchMainApi('GET', `/trucks/${equipmentId}/images`)
}

export const deleteEquipmentImage = async (equipmentId, imageId) => {
  return fetchMainApi('DELETE', `/trucks/${equipmentId}/images/${imageId}`)
}
